export default "__VITE_ASSET__BjXi9Cgz__"